import PortfolioSettingsRouter from "./PortfolioSettingsRouter";

export default PortfolioSettingsRouter;
